// extracted by mini-css-extract-plugin
export var cardButtons = "whats-new-result-item-module--cardButtons--5725d";
export var cardLabel = "whats-new-result-item-module--cardLabel--9db1a";
export var dark = "whats-new-result-item-module--dark--a51a1";
export var description = "whats-new-result-item-module--description--97df4";
export var image = "whats-new-result-item-module--image--850c4";
export var imageContainer = "whats-new-result-item-module--imageContainer--337d9";
export var light = "whats-new-result-item-module--light--a5971";
export var postTopic = "whats-new-result-item-module--postTopic--8b0c2";
export var postTopics = "whats-new-result-item-module--postTopics--56620";
export var releaseType = "whats-new-result-item-module--releaseType--58906";
export var searchResult = "whats-new-result-item-module--searchResult--149d0";
export var separator = "whats-new-result-item-module--separator--49f70";
export var textContainer = "whats-new-result-item-module--textContainer--61a2f";
export var title = "whats-new-result-item-module--title--8b056";